<template>
  <RouterView />
</template>

<script setup lang="ts">
import { watch, onMounted } from 'vue'
import { useColors } from 'vuestic-ui'

const { currentPresetName, getColor } = useColors()

const applyThemeColors = () => {
  const isDark = currentPresetName.value === 'dark'
  const root = document.documentElement
  const body = document.body

  // Add/remove dark class
  if (isDark) {
    body.classList.add('dark')
    root.classList.add('dark')
  } else {
    body.classList.remove('dark')
    root.classList.remove('dark')
  }

  // Force apply Vuestic colors to CSS variables
  const bgSecondary = getColor('background-secondary')
  const bgPrimary = getColor('background-primary')
  const textPrimary = getColor('primary')
  const textSecondary = getColor('secondary')

  root.style.setProperty('--va-background-secondary', bgSecondary)
  root.style.setProperty('--va-background-primary', bgPrimary)
  root.style.setProperty('--va-text-primary', textPrimary)
  root.style.setProperty('--va-text-secondary', textSecondary)

  // Force re-render of all data tables
  const tables = document.querySelectorAll('.va-data-table')
  tables.forEach((table) => {
    ;(table as HTMLElement).style.backgroundColor = bgSecondary
    ;(table as HTMLElement).style.color = textPrimary
  })
}

// Initial apply on mount
onMounted(() => {
  // Wait a bit for Vuestic to initialize
  setTimeout(applyThemeColors, 100)
})

// Watch for theme changes
watch(
  () => currentPresetName.value,
  () => {
    applyThemeColors()
  },
  { flush: 'post' },
)
</script>

<style lang="scss">
#app {
  font-family:
    system-ui,
    -apple-system,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

// Sécurité pour forcer les boutons et les champs de texte à utiliser la police système
input,
select,
textarea,
button {
  font-family: inherit;
}

body {
  margin: 0;
  min-width: 20rem;
}

/* Dark mode styles */
:root.dark {
  color-scheme: dark;
}
</style>
